export default __webpack_public_path__ + "static/media/Heater-4_1.0c29815e.mp3";